import { render, staticRenderFns } from "./TrendyolChannels.vue?vue&type=template&id=231261ce&scoped=true"
import script from "./TrendyolChannels.vue?vue&type=script&lang=js"
export * from "./TrendyolChannels.vue?vue&type=script&lang=js"
import style0 from "./TrendyolChannels.vue?vue&type=style&index=0&id=231261ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231261ce",
  null
  
)

export default component.exports